import { useTranslation } from 'react-i18next';

import { StyledDrawerTitle } from 'common/styled/Drawer.style';
import OrderErrors from 'pages/Checkout/types/orderError.types';

const CreateOrderErrorHeader: React.FC<{
  errorCode: string;
}> = ({ errorCode }) => {
  const { t } = useTranslation();

  let heading = '';

  if (errorCode === OrderErrors.PMV_101 || errorCode === OrderErrors.PMV_102) {
    heading = t('createOrderError.bankDiscountFailed');
  } else if (errorCode === OrderErrors.PMV_103) {
    heading = t('createOrderError.discountFailed');
  }

  return <StyledDrawerTitle>{heading}</StyledDrawerTitle>;
};

export default CreateOrderErrorHeader;
